import { render, staticRenderFns } from "./TijianMain.vue?vue&type=template&id=12190fde&scoped=true"
import script from "./TijianMain.vue?vue&type=script&lang=js"
export * from "./TijianMain.vue?vue&type=script&lang=js"
import style0 from "./TijianMain.vue?vue&type=style&index=0&id=12190fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12190fde",
  null
  
)

export default component.exports